module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "section_title"
  }, [_c('a', {
    attrs: {
      "id": "set"
    }
  }), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('span', {
    staticClass: "green"
  }, [_vm._v("THE SETUP")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/line.jpg"
    }
  })])]), _vm._v(" "), _c('h2', {
    staticClass: "chapter_hd"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Garnishes and Other Special Touches")])]), _vm._v(" "), _c('h3', [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "id": "pg11lev1"
    }
  }), _c('span', {
    staticClass: "red"
  }, [_vm._v("CITRUS GARNISHES")])]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent"
  }, [_vm._v("From wheels to peels, citrus garnishes are almost always the perfect accessory for a well-dressed drink.")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('strong', [_c('span', {
    staticClass: "font"
  }, [_vm._v("PEELS:")])]), _vm._v(" Use a knife or vegetable peeler to cut a swath of zest from the fruit. Many bartenders encourage using the serving glass for inspiration. Cut wide pieces of peel for sturdy vessels like rocks glasses, and trim thinner pieces for graceful coupes or Champagne flutes. Peels are often called “twists” because many bartenders will quickly twist the citrus peel over the surface of a drink to release its essential oils, adding a burst of aroma.")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('strong', [_c('span', {
    staticClass: "font"
  }, [_vm._v("WEDGES:")])]), _vm._v(" For wedges, cut lemons or limes into quarters. Cut oranges into eighths. Pineapple wedges also are called for in this book.")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('strong', [_c('span', {
    staticClass: "font"
  }, [_vm._v("WHEELS:")])]), _vm._v(" Cut the ends off a lemon, lime, grapefruit, or orange and discard. Slice the fruit into rounds about "), _c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("4")]), _vm._v(" in [6 mm] thick. If the wheel will be perched on the edge of the glass, cut a slit from the center of the wheel to the outer peel. Cucumber wheels (slices) also are called for in this book.")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('strong', [_c('span', {
    staticClass: "font"
  }, [_vm._v("HALF-WHEELS:")])]), _vm._v(" Cut a wheel in half, creating a semicircle that can be tucked into a glass with ice or floated on top of a drink.")]), _vm._v(" "), _c('h3', [_c('a', {
    attrs: {
      "id": "pg11lev2"
    }
  }), _c('span', {
    staticClass: "red"
  }, [_vm._v("HERB GARNISHES")])]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent"
  }, [_vm._v("Mint sprigs are called for in a number of recipes in this book. Trim into small bunches, with just enough stem to prop upright in a drink. Some bartenders briefly crush "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _vm._v("or smack the leaves as they garnish a drink, to release essential oils and maximum aroma. Other herbs suitable for garnishes include basil, cilantro, and shiso leaves.")]), _vm._v(" "), _c('h3', [_c('a', {
    attrs: {
      "id": "pg12lev1"
    }
  }), _c('span', {
    staticClass: "red"
  }, [_vm._v("SPICE GARNISHES")])]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent"
  }, [_vm._v("Nutmeg is frequently called upon as a garnish; in this book, you can find it in the Brandy Alexander chapter (drink number 2). Most bartenders recommend purchasing whole nutmegs and grating the spice directly over a drink for maximum aroma and flavor. However, using powdered nutmeg will do if needed. Cinnamon sticks also are part of the garnish toolbox, whether grated atop a drink or used to stir a Hot Toddy (drink number 5). And if you happen to have whole vanilla beans on hand, they can be used to stir a drink, brewed into a syrup, or pulverized into vanilla salt to rim a Paloma variation (see the Palomita, inside drink number 16).")]), _vm._v(" "), _c('h3', [_c('a', {
    attrs: {
      "id": "pg12lev2"
    }
  }), _c('span', {
    staticClass: "red"
  }, [_vm._v("BRANDIED CHERRIES")])]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent"
  }, [_vm._v("Drop them into a coupe or spear on toothpicks to garnish such drinks as Whiskey Sour variations (inside drink number 21) and Manhattan variations (inside drink number 8), although they’re great for pretty much any whiskey-based drink. Brandied cherries can be purchased (try Luxardo maraschino cherries). Avoid bright pink, artificially flavored “maraschino cherries.”")]), _vm._v(" "), _c('h3', [_c('a', {
    attrs: {
      "id": "pg12lev3"
    }
  }), _c('span', {
    staticClass: "red"
  }, [_vm._v("SYRUPS")])]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent"
  }, [_vm._v("Compared to straight granulated sugar, which often doesn’t dissolve completely into drinks, syrups sweeten without disturbing the texture of cocktails.")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('a', {
    attrs: {
      "id": "pg13lev1"
    }
  }), _c('strong', [_c('span', {
    staticClass: "font"
  }, [_vm._v("SIMPLE SYRUP:")])]), _vm._v(" Stir 1 part sugar into 1 part hot water until the sugar dissolves. Remove from the heat and let cool. Decant into a lidded container and store in the refrigerator for up to 10 days.")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('a', {
    attrs: {
      "id": "pg13lev2"
    }
  }), _c('strong', [_c('span', {
    staticClass: "font"
  }, [_vm._v("RICH SIMPLE SYRUP:")])]), _vm._v(" This creates a more concentrated, sweeter syrup. Stir 2 parts sugar into 1 part hot water until the sugar dissolves. Remove from the heat and let cool. Decant into a lidded container and store in the refrigerator for up to 10 days.")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('a', {
    attrs: {
      "id": "pg13lev3"
    }
  }), _c('strong', [_c('span', {
    staticClass: "font"
  }, [_vm._v("DEMERARA SYRUP:")])]), _vm._v(" This is the same as simple syrup, but uses richer, darker demerara sugar instead of white sugar. The finished syrup has a deeper color and flavor, which some bartenders prefer for drinks made with darker spirits, such as whiskey, brandy, or aged rum. Mix 1 part demerara sugar with 1 part hot water. Stir until the sugar completely dissolves. Remove from the heat and let cool. Decant into a lidded container and store in the refrigerator for up to 10 days.")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_c('em', [_vm._v("Try it in the Silver Sour (inside drink number 21)")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('a', {
    attrs: {
      "id": "pg13lev4"
    }
  }), _c('strong', [_c('span', {
    staticClass: "font"
  }, [_vm._v("RICH DEMERARA SYRUP:")])]), _vm._v(" This creates a more concentrated, sweeter syrup. Stir 2 parts demerara sugar into 1 part hot water until the sugar dissolves. Remove from the heat and let cool. Decant into a lidded container and store in the refrigerator for up to 10 days.")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_c('em', [_vm._v("Try it in the Autumn Daiquiri (inside drink number 3), or the Southern Limerick (inside drink number 6)")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('a', {
    attrs: {
      "id": "pg14lev1"
    }
  }), _c('strong', [_c('span', {
    staticClass: "font"
  }, [_vm._v("HONEY SYRUP:")])]), _vm._v(" This thins the consistency of honey, so it dissolves more easily into a cocktail. Stir 1 part honey into 1 part hot water. It will take some stirring to get the honey to dissolve and incorporate. Remove from the heat and let cool (or use while still warm for maximum pourability). Decant into a lidded container and store in the refrigerator for up to 10 days.")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_c('em', [_vm._v("Try it in the Apple Toddy (inside drink number 5)")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('a', {
    attrs: {
      "id": "pg14lev2"
    }
  }), _c('strong', [_c('span', {
    staticClass: "font"
  }, [_vm._v("RICH HONEY SYRUP:")])]), _vm._v(" Stir 3 parts honey into 1 part hot water. It will take some stirring to get the honey to dissolve and incorporate. Remove from the heat and let cool (or use while still warm for maximum pourability). Decant into a lidded container and store in the refrigerator for up to 10 days.")]), _vm._v(" "), _c('p', {
    staticClass: "first2_noindent"
  }, [_c('em', [_vm._v("Try it in the Gold Rush (inside drink number 21)")]), _vm._v(".")]), _vm._v(" "), _c('h2', {
    staticClass: "chapter_title"
  }, [_c('a', {
    attrs: {
      "id": "pg14lev3"
    }
  }), _c('span', {
    staticClass: "red"
  }, [_vm._v("More tips and techniques")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('strong', [_c('span', {
    staticClass: "font"
  }, [_vm._v("CHILLING GLASSES")])])]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent"
  }, [_vm._v("This is one of the easiest techniques possible, which bars employ all the time to elevate their drinks. All it takes is to place your glassware in the freezer. That’s it. If possible, leave glassware in the freezer for about 30 minutes before making drinks for a full-on frosty effect that looks great and keeps the drinks chilled as long as possible. If you’ve forgotten to plan ahead, place the glasses in the freezer and start making the drinks, then fish them out when you’re ready to pour. Even 5 minutes makes a noticeable difference.")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _vm._v("Chilling a glass is less important if you’re making a drink served on the rocks—in other words, if ice will be in the glass, it will serve to keep the drink cold. But for a drink that’s strained and served “up”—without ice—a chilled glass makes a big difference in keeping the drink as cold as possible for as long as possible.")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('a', {
    attrs: {
      "id": "pg15lev1"
    }
  }), _c('strong', [_c('span', {
    staticClass: "font"
  }, [_vm._v("WARMING GLASSES")])])]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent"
  }, [_vm._v("To serve toddies and other drinks warm, rinse a glass with a handle (like a footed Irish Coffee glass) or mug with very hot water. Spill out the water, then build the drink in the warmed glass. For drinks that require more preparation, first mix the drink in a cocktail shaker or mixing glass. When it’s ready to go, warm the glass and then pour the prepared drink into the warmed glass.")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('strong', [_c('span', {
    staticClass: "font"
  }, [_vm._v("MUDDLING")])])]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent"
  }, [_vm._v("Use a muddler—a blunt tool made of wood or plastic—or a wooden spoon inside a cocktail shaker or pitcher to gently crush herbs or release juices from pieces of fruit or vegetables. In Old Fashioned variations, muddling is used to crush sugar cubes and mix the pulverized sugar with bitters or other flavorings.")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('strong', [_c('span', {
    staticClass: "font"
  }, [_vm._v("SWIZZLING")])])]), _vm._v(" "), _c('p', {
    staticClass: "first1_noindent"
  }, [_vm._v("Borrowed from Caribbean tradition, this technique is used to stir drinks, particularly those densely packed with crushed ice, where there might not be sufficient room for circular stirring. The tool of choice is a wooden swizzle stick or long-handled spoon. Hold the utensil between your palms and roll it, so the ingredients mix together.")]), _vm._v(" "), _c('h2', {
    staticClass: "chapter_title"
  }, [_c('span', {
    staticClass: "red"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('a', {
    attrs: {
      "id": "pg16lev1"
    }
  }), _vm._v("Some equipment")])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('strong', [_c('span', {
    staticClass: "font"
  }, [_vm._v("JIGGER:")])]), _vm._v(" Used to measure liquids. Be aware that jiggers come in many sizes; check how many ounces or milliliters your jigger holds on each side before using it.")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('strong', [_c('span', {
    staticClass: "font"
  }, [_vm._v("COCKTAIL SHAKER:")])]), _vm._v(" Either a two-piece Boston shaker or a three-piece cobbler shaker, depending on what you prefer.")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('strong', [_c('span', {
    staticClass: "font"
  }, [_vm._v("LONG-HANDLED SPOON/BAR SPOON:")])]), _vm._v(" Perfect for reaching down into the bottom of a mixing glass or pitcher to stir thoroughly.")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('strong', [_c('span', {
    staticClass: "font"
  }, [_vm._v("MIXING GLASS:")])]), _vm._v(" Although any large glass or pitcher can be used for this purpose, a mixing glass is intended for stirring drinks with ice. Some have spouts to make for easy pouring.")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('strong', [_c('span', {
    staticClass: "font"
  }, [_vm._v("MUDDLER:")])]), _vm._v(" A muddler usually has a blunt or rounded edge, like a mini baseball bat, meant for crushing herbs, spices, or other ingredients. The back of a spoon also can be used in a pinch.")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_c('strong', [_c('span', {
    staticClass: "font"
  }, [_vm._v("STRAINER:")])]), _vm._v(" A Hawthorne bar strainer is flat and equipped with a spring coil, so it fits neatly into a shaker tin to prevent ice from falling into a drink. A julep strainer has a bowl-shaped cup that nestles inside a mixing glass, making it ideal for straining stirred drinks.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8702cd6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06setup.vue
// module id = 72
// module chunks = 0